import { 
  addToStoredArray, 
  getStoredArray, 
  removeStoredArrayElement, 
  updateStoredArrayElement
} from './Storage';

export const getUpdates = async () => {
  let updates = await getStoredArray('updateStack');

  let first = [];
  let last = [];

  updates.forEach(update => {
    if (update.value.action !== 'add_note_to_job') {
      first.push(update);
    } else {
      last.push(update);
    }
  });

  return [...first, ...last];
}

export const addUpdate = async (action, data) => {
  return await addToStoredArray(
    'updateStack',
    {action, retryCount: 0, data}
  );
}

export const ammendUpdate = async (ref, data) => {
  return await updateStoredArrayElement(
    'updateStack',
    ref,
    data
  );
}

export const removeUpdate = async (ref) => {
  return await removeStoredArrayElement(
    'updateStack', 
    ref
  );
}

export const addProcessedUpdate = async (data) => {
  return await addToStoredArray(
    'processedUpdates',
    data
  );
}

export const addFailedUpdate = async (data) => {
  return await addToStoredArray(
    'failedUpdates',
    data
  );
}

export const addToLog = async (action, data) => {
  const dataClone = JSON.parse(JSON.stringify(data));

  if (dataClone.value && dataClone.value.data) {
    // delete documents & photos because they are base64 encoded files..
    if (dataClone.value.data.documents) { delete dataClone.value.data.documents; }
    if (dataClone.value.data.photos) { delete dataClone.value.data.photos; }
  }

  return await addToStoredArray(
    'log',
    { action, data: dataClone }
  );
}

export const getLog = async () => {
  return await getStoredArray('log');
}